import _ from "lodash"

// test: jest src/models/__tests__/Booking.model.spec.js
export default class Booking {
  constructor(rawData) {
    this._rawData = rawData;
  }

  get serviceIdInArray() {
    const serviceIdRawValue = _.get(this._rawData, 'service_id')
    if (!serviceIdRawValue) {
      return []
    }
    const parsedServiceId = typeof serviceIdRawValue === 'string' ? JSON.parse(serviceIdRawValue) : serviceIdRawValue
    return Array.isArray(parsedServiceId) ? parsedServiceId : [parsedServiceId]
  }

  get value() {
    return _.get(this._rawData, 'value')
  }
}
